import { render, staticRenderFns } from "./collapse-container.vue?vue&type=template&id=551864a2&"
import script from "./collapse-container.vue?vue&type=script&lang=js&"
export * from "./collapse-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports